import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-recently-viewed-init')) return;
    this.setAttribute('data-recently-viewed-init', '');

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const viewedProducts = RecentlyViewed.getProducts();
    if (!Array.isArray(viewedProducts) || viewedProducts.length === 0) {
      this.setAttribute('hidden', '');
      return;
    }
    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set(
      'q',
      viewedProducts.map((id) => `id:${id}`).join(' OR ')
    );
    url.searchParams.set('resources[type]', 'product');

    sectionRenderer.renderSection(sectionId, { cache: false, url });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedSection);
}
